<template>
  <div></div>
</template>
<script>
const CryptoJS = require("crypto-js"); //引用加密源码js
export default {
  name: "JinShuiTemp",
  data() {
    return {
      // userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
      path: "",
    };
  },
  created() {
    this.$Common.getServerTime();

    this.getUrlParam(window.location.href);
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    schoolBidDataVersion() {
      return this.$store.state.schoolBidDataVersion;
    },
    eduBidDataVersion() {
      return this.$store.state.eduBidDataVersion;
    },
  },
  methods: {
    goBack() {
      // console.log(this.userInfo,11)
      if (this.userInfo == null) {
        this.$router.push("/login");
        return;
      }
      if (this.userInfo.eduId == 0) {
        this.$router.push("/schoolIndex_" + this.schoolBidDataVersion);
      } else {
        this.$router.push("/eduSecuritySituation_" + this.eduBidDataVersion);
      }
    },
    getUrlParam(theUrl) {
      /*获取地址，若有传参则为参数，否则为当前页面地址*/
      var thisUrl = theUrl || location.href || "";
      // if()
      /*创建一个用于存储参数的对象*/
      var paramObj = new Object();
      /*若存在‘？’，说明地址携带参数，否则没带参数*/
      if (thisUrl.indexOf("?") != -1) {
        /*截取地址中从‘？’下一位开始的字符串，即参数字段*/
        var str = thisUrl.substr(thisUrl.indexOf("?") + 1);

        var strs = str.split("&");
        /*参数存储于对象之中*/
        for (var i = 0; i < strs.length; i++) {
          /*decodeURIComponent() 对编码后的 URI 进行解码*/
          paramObj[strs[i].split("=")[0]] = decodeURIComponent(strs[i].split("=")[1]);
        }
      }
      // console.log(paramObj)
      this.getUserInfo(paramObj);
      // return paramObj;
      // let obj =  JSON.stringify(paramObj);
      // if (obj != "{}") {
      //   // this.authorizeLogin(paramObj.iflyssost);
      // }
    },
    async getUserInfo(item) {
      // console.log(item,111)
      this.path = item.route;
      let ticket = CryptoJS.enc.Base64.parse(item.ticket).toString(CryptoJS.enc.Utf8);
      // console.log(ticket,item.ticket)
      let req = {
        ticket: ticket,
      };
      let res = await this.$httpJinshui.getTicketInfo(req, true);
      if (res.code == 200) {
        let data = CryptoJS.enc.Base64.parse(res.data).toString(CryptoJS.enc.Utf8);
        // console.log(JSON.parse(data),333)
        // return JSON.parse(data)
        this.dataStorage(JSON.parse(data));
      } else {
        this.$message({
          message: res.messsage,
          type: "error",
        });
      }
    },
    dataStorage(data) {
      var userInfo = {
        userId: data.userId,
        userName: data.userName,
        userPhone: data.userPhone,
        email: data.email,
        token: data.token,
        userIdNumber: data.userIdNumber,
        loginId: data.loginId,
        headPortrait: data.headPortrait,
        eduId: data.eduId,
        eduBuresuType: data.eduBuresuType,
        logisticsId: data.logisticsId,
        schoolId: data.schoolId,
        roleId: data.roleId,
      };
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      var newUserInfo = sessionStorage.getItem("userInfo");
      this.$store.commit("updateUserInfo", newUserInfo);

      sessionStorage.setItem("schoolId", data.schoolId);
      this.$store.commit("updateSchoolId", sessionStorage.getItem("schoolId"));
      // this.getUnreadMessages(userInfo.userId);
      this.$Common.getNoticesNumber(1);
      if (userInfo.eduId == 0) {
        // this.$router.push(this.path);
        // this.$Common.pageJump(this.path, 0);
        this.sel(this.path);
      } else {
        this.getEduInfo();
      }
    },
    sel(path) {
      switch (path) {
        case "/not_done_matter":
          this.$store.commit("updatePathIndex", "2-0");
          this.$Common.pageJump(path, "2-0", 0);
          this.$store.commit("setSelect", true);
          break;
        case "/risk_assessment":
          this.$store.commit("updatePathIndex", "0-2-1");
          this.$Common.pageJump(path, "0-2-1", 0);
          this.$store.commit("setSelect", false);
          break;
        case "/hidden_danger_data":
          this.$store.commit("updatePathIndex", "1-0-0");
          this.$Common.pageJump(path, "1-0-0", 0);
          this.$store.commit("setSelect", false);
          break;
        case "/patrol_task":
          this.$store.commit("updatePathIndex", "1-2-2");
          this.$Common.pageJump(path, "1-2-2", 0);
          this.$store.commit("setSelect", false);
          break;
        case "/risk_hidden_danger":
          // this.$store.commit("updatePathIndex", '1-2-2');
          this.$store.commit("setSelect", false);
          sessionStorage.setItem("schoolBigSelect", "2");
          // console.log(sessionStorage.getItem("schoolBigSelect"))
          if (this.schoolBidDataVersion == 1) {
            this.$Common.pageJump(path, "", 0);
          } else {
            this.$Common.pageJump(
              "risk_hidden_danger_" + this.schoolBidDataVersion,
              "",
              0
            );
          }

          break;
        case "/eduSecuritySituation":
          this.$Common.pageJump(
            "eduSecuritySituation_" + this.schoolBidDataVersion,
            "",
            0
          );
          break;
        default:
          break;
      }
      // if (a) {
      //   this.$store.commit("updatePathIndex", a);
      // }
      // if (path == "/basics_info") {
      //   sessionStorage.setItem("schoolBigSelect", 0);
      // }
      // this.$Common.pageJump(path, a, num);
      // this.$store.commit("setSelect", b);
    },
    async getUnreadMessages(userId) {
      let res = await this.$Http.getUnreadMessages({
        userId: userId,
      });
      if (res.code == 200) {
        this.$store.commit("unreadMessages", res.data.number || 0);
      } else {
        this.$store.commit("unreadMessages", 0);
      }
    },
    // 获取教育局信息
    async getEduInfo() {
      var requestData = {
        eduId: this.$store.getters.getUserInfo.eduId,
      };
      let res = await this.$Http.getEduInfo(requestData);
      if (res.code == 200) {
        var eduInfo = res.data;
        sessionStorage.setItem("eduInfo", JSON.stringify(eduInfo));
        if (sessionStorage.getItem("eduInfo")) {
          this.$store.commit("updateEduInfo", sessionStorage.getItem("eduInfo"));
          // console.log(this.$store.getters.getEduData);

          this.$nextTick(() => {
            // this.$router.push('/group_basic_info')
            if (eduInfo.eduBuresuType == -1) {
              // 高校版本
              // this.$Common.pageJump("/newUniversityBigData", 2, 0);
              // this.$router.push(this.path);
            } else if (eduInfo.eduBuresuType == -2) {
              // 后勤总公司
              // this.$Common.pageJump("/l_user_data", 2, 0);
            } else {
              // 教育局版本
              this.$Common.pageJump(
                "/eduSecuritySituation_" + this.eduBidDataVersion,
                2,
                0
              );
            }
          });
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error",
        });
      }
    },
  },
  mounted() {},
};
</script>
<style scoped lang="scss"></style>
